import {Popover} from "antd";
import React, {ReactElement, useMemo} from "react";
import {formatMoney} from "@lib/format";

export interface FmvPriceProps {
    prefix?: ReactElement | string | null;
    value: number | null;
    stale?: boolean | null;
    staleInfo?: string | null;
}

const FmvPrice = ({value, stale, prefix, staleInfo}: FmvPriceProps) => {

    const price = formatMoney(value);
    const content = useMemo(() => (
        <>
            {prefix && (
                <span className={(stale ? 'fmv-price-stale' : '')}>
                    {prefix}
                </span>
            )}
            <span className={(stale ? 'fmv-price-stale' : '')}>
                {price}{(price !== '--' && stale) ? '*' : ''}
            </span>
        </>
    ), [prefix, stale, value])

    return stale ? (
        <Popover content={stale ? staleInfo ? staleInfo : "* indicates sales older than 90 days" : null}>
            {content}
        </Popover>
    ) : content;
}

export default FmvPrice;